import React from 'react'

function Kadra() {
  return (
    <div>Kadra</div>
  )
}

export default Kadra